module.exports = __webpack_public_path__ + "fonts/Poppins-Light.e577e3ba.woff2";